import { RightOutlined } from "@ant-design/icons";
import React, { useEffect, useState } from 'react'
import { Button, Col, Form, Input, PageHeader, Row, Select, Space } from 'antd'

import JcpMonthlyPaidListView from '../../components/enrollment/jcp/JcpMonthlyPaidListView'
import ProgrammeService from '../../api/programme.service'
import AdminBreadCrumb from '../../components/layout/AdminBreadCrumb'
import PaymentPaidList from '../../components/payment/PaymentPaidList'

import { SUCCESS_STATUS } from '../../utility/Constants'
import memberService from "../../api/member.service";
const { Option } = Select;



const defaultFormValues = {
    month_id : "",
    year:"",
    member_id:"",
    programme_id:0
};
  

const JcpMonthlyPaidList = () => {
    const [form] = Form.useForm();
    const [monthList, setMonthList] = useState([]);
    const [yearList, setYearList] = useState([]);
    const [memberList, setMemberList] = useState([]);
    const [programmeID, setProgrammeID] = useState(0);
    const [jcpMonthlyPaidList, setJcpMonthlyPaidList] = useState([]);








    const onJcpMonthlySearched = async (values) => {
        const data = { formdata: values };
        console.log(values);


        ProgrammeService.monthlyPaidJcp(data).then((res) => {
            //console.log("Response", res)
            setJcpMonthlyPaidList(res.data.response_data)

        });


    };




    const onSelectMember = (value) => {
        const data = { formdata: { member_id: value } };
    };

    useEffect(() => {
        ProgrammeService.yearList().then((res) => {
            if (res.data.response_status === SUCCESS_STATUS) {
                setYearList(res.data.response_data);
            }

        });
    }, []);


    useEffect(() => {
        ProgrammeService.monthList().then((res) => {
            if (res.data.response_status === SUCCESS_STATUS) {
                setMonthList(res.data.response_data);
            }

        });
    }, []);


    useEffect(() => {
        const data = {
            formdata: { short_code: "JCP" },
        };
        ProgrammeService.programmeByCode(data).then((res) => {
            if (res.data.response_status === SUCCESS_STATUS) {
                setProgrammeID(res.data.response_data[0].programme_id);
                form.setFieldsValue({
                    programme_id: res.data.response_data[0].programme_id,
                });
            }
        });
    }, []);


    useEffect(() => {
        memberService.allMember().then((res) => {
            if (res.data.response_status === SUCCESS_STATUS) {
                setMemberList(res.data.response_data);
            }
        });
    }, []);






    return (




        <div>


            <div className="inside-main-content">
                <AdminBreadCrumb />

                <div className="box-style">
                    <PageHeader
                        ghost={false}
                        onBack={() => window.history.back()}
                        title="Monthly Paid List - JCP"
                        subTitle=""

                    ></PageHeader>

                    <Row className="" style={{ background: "transparent" }}>
                        <Col className="" xs={24} xl={24}>
                            <Form
                                form={form}
                                layout="vertical"
                                onFinish={onJcpMonthlySearched}
                                autoComplete="off"
                             initialValues={defaultFormValues}
                            >

                                <Row gutter={20}>

                                    <Col xs={4} xl={4} style={{ margin: "0.5rem" }}>
                                        <Form.Item name="month_id" label="Month" rules={[
                            {
                              required: true,
                              message: "Select Month",
                            },
                          ]}>
                                            <Select className="text-left">

                                                {
                                                    monthList.length > 0 ?
                                                        monthList.map(month_list => (
                                                            <Option key={month_list.id} value={month_list.id}>{month_list.short_name}</Option>

                                                        ))
                                                        : ''
                                                }
                                            </Select>
                                        </Form.Item>
                                    </Col>

                                    <Col xs={4} xl={4} style={{ margin: "0.5rem" }}>
                                        <Form.Item name="year" label="Year" rules={[
                            {
                              required: true,
                              message: "Select Year",
                            },
                          ]} >
                                            <Select className="text-left"  >

                                                {
                                                    yearList.length > 0 ?
                                                        yearList.map(year_data => (
                                                            <Option key={year_data.year} value={year_data.year}>{year_data.year}</Option>

                                                        ))
                                                        : ''
                                                }
                                            </Select>
                                        </Form.Item>
                                    </Col>

                                    <Col xs={6} xl={8} style={{ margin: "0.5rem" }}>
                                        <Form.Item
                                            name="member_id"
                                            label="Search (Name | Mobile no | Father Name)"
                                            
                                        >
                                            <Select
                                                showSearch
                                                placeholder="Search to Select"
                                                optionFilterProp="children"
                                                filterOption={(input, option) =>
                                                    option.children.includes(input)
                                                }
                                                filterSort={(optionA, optionB) =>
                                                    optionA.children
                                                        .toLowerCase()
                                                        .localeCompare(optionB.children.toLowerCase())
                                                }
                                                onSelect={(value, event) =>
                                                    onSelectMember(value, event)
                                                }
                                                allowClear={true}
                                            >
                                                {memberList.length > 0
                                                    ? memberList.map((member_list) => (
                                                        <Option
                                                            key={member_list.member_id}
                                                            value={member_list.member_id}
                                                        >
                                                            {`${member_list.member_fname} ${member_list.member_lname
                                                                } | ${member_list.primary_mobile}  ${member_list.father_name != null
                                                                    ? member_list.father_name
                                                                    : ""
                                                                }`}
                                                        </Option>
                                                    ))
                                                    : ""}
                                            </Select>
                                            <Form.Item name="programme_id" hidden={true}>
                                                <Input type="text" />
                                            </Form.Item>
                                        </Form.Item>
                                    </Col>

                                    <Col xs={4} xl={4} style={{ margin: "0.5rem" }}>
                                        <Form.Item label=" ">
                                            <Button type="primary" htmlType="submit" shape="round">Show</Button>

                                        </Form.Item>
                                    </Col>


                                </Row>
                            </Form>



                        </Col>
                    </Row>


                    <div className='tableView'>
                        <div className="form-content">
                            <JcpMonthlyPaidListView jcpMonthlyPaidList = {jcpMonthlyPaidList} />
                        </div>
                    </div>

                </div>
            </div>

        </div>







    )
}

export default JcpMonthlyPaidList